export const getJoyrideLocales = (translate) => ({
  back: translate('tour.back'),
  close: translate('tour.close'),
  last: translate('tour.last'),
  next: translate('tour.next'),
  skip: translate('tour.skip')
})
